console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_TENNIS
const BASEURL_API = process.env.VUE_APP_APIURL_API

// 网球 【中网】 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// 获取赛季 接口
export const https_tennis_seasonList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/cmp/findseasoninfos/${params.cid}`)
  )
}

// 获取赛季下的组别列表 接口
export const https_season_eventList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/schedule/getEvents`), params)
}

// 获取赛程列表 接口
export const https_schedule_matchList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getEventSchedules`),
    params
  )
}

// 获取赛果 【基本信息 || 出场名单 || 本场数据 】 接口
export const https_scheduleDetail_matchDetailData = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getScheduleResult`),
    params
  )
}

// 获取积分榜 接口
// export const https_tennis_leagueTable = (baseUrl, axios, params) => {
//   return axios.post(computedBaseUrl(`${baseUrl}/standing/getStanding`), params)
// }

// 获取淘汰赛 接口
export const https_tennis_knockoutData = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getKnockoutMatch`),
    params
  )
}

// 获取场地 接口
export const https_tennis_getVenues = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/schedule/getVenues`), params)
}

// 获取比赛日期 接口
export const https_tennis_getScheduleDate = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getScheduleDate`),
    params
  )
}
